/*
 * @Descripttion:
 * @Author: Xinner
 * @Date: 2021-01-26 09:28:03
 * @LastEditors: 景 彡
 * @LastEditTime: 2024-06-11 09:39:05
 */
/*
自动生成代码，请不要手工修改
create at 11&#x2F;4&#x2F;20204:08:37 PM
*/
import {
  ClientLoginUser,
  DealWithResultDto,
  ChangePasswordModel,
  ApiResponseData,
  ApiJsonResult,
  IPagedList,
  IPagedEnumberable,
  PagedList,
  TreeNode,
} from './models';
import apiRequest, { apiSendAsync } from '@/utils/apiRequest';

// tslint:disable-next-line:no-namespace
export namespace Clients {
  export async function validateLogon_POST(
    model: ClientLoginUser,
    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiJsonResult<object>>('POST', '/api/Client/ValidateLogon', model, query);
  }

  export async function changePassword_POST(
    model: ChangePasswordModel,
    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiJsonResult<object>>('POST', '/api/Client/ChangePassword', model, query);
  }
}

export namespace Yq {
  // 提交处置结果
  export async function sumbitDealWithResult_POST(
    model: DealWithResultDto,
    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<object>>('POST', '/api/Yq/SumbitDealWithResult', model, query);
  }

  // 获取舆情事件趋势统计接口
  export async function getDayStatistics_GET(query: {
    st: Date | null;
    et: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    type: string | null;
    city: string | null;
    county: string | null;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetDayStatistics', null, query);
  }

  // 获取舆情事件发生时间段统计接口
  export async function getTimePeriodStatistics_GET(query: {
    st: Date | null;
    et: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    type: string | null;
    city: string | null;
    county: string | null;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetTimePeriodStatistics', null, query);
  }

  // 获取舆情事件发生地统计接口
  export async function getCityStatistics_GET(query: {
    st: Date | null;
    et: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    type: string | null;
    city: string | null;
    county: string | null;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetCityStatistics', null, query);
  }

  // 获取舆情事件来源统计接口
  export async function getSourceStatitics_GET(query: {
    st: Date | null;
    et: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    type: string | null;
    city: string | null;
    county: string | null;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetSourceStatitics', null, query);
  }

  // 获取舆情事件类别统计接口
  export async function getEventStatistics_GET(query: {
    st: Date | null;
    et: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    type: string | null;
    city: string | null;
    county: string | null;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetEventStatistics', null, query);
  }

  // 获取舆情事件类别统计接口
  export async function GetYqData_GET(query: { tag: string | null }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/yq/GetYqData', null, query);
  }

  // 获取舆情事件类别统计接口
  export async function GetTagsStatistics_GET(query: {
    st: Date | null;
    et: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    type: string | null;
    city: string | null;
    county: string | null;
    [key: string]: any;
    tag: string | null;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetTagsStatistics', null, query);
  }

  // 疑似舆情查询接口
  export async function getYsyq_GET(query: {
    startCrawlTime: Date | null;
    endCrawlTime: Date | null;
    startPublishTime: Date | null;
    endPublishTime: Date | null;
    keyword: string | null;
    title: string | null;
    text: string | null;
    type: string | null;
    size: number;
    p: number;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetYsyq', null, query);
  }

  // 今日舆情查询接口
  export async function getToday_GET(query: {
    eventCategoryId: string | null;
    keyword: string | null;
    theme: string | null;
    publisher: string | null;
    source: string | null;
    city: string | null;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetToday', null, query);
  }

  // 舆情日报管理接口
  export async function getAll_GET(query: {
    isPositive?: boolean | null;
    reportState: boolean | null;
    eventCategoryId: string | null;
    keyword: string | null;
    theme: string | null;
    publisher: string | null;
    source: string | null;
    startPublishTime: Date | null;
    endPublishTime: Date | null;
    startCreationTime: Date | null;
    endCreationTime: Date | null;
    size: number;
    p: number;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetAll', null, query);
  }

  // 获取所有事件分类接口
  export async function getAllCategories_GET() {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetAllCategories', null, null);
  }

  // 获取所有标准数据接口
  export async function getAllStandards_GET() {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetAllStandards', null, null);
  }

  // 根据key获取标准数据项
  export async function getAllStandardItems_GET(query: { key: string; [key: string]: any }) {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetAllStandardItems', null, query);
  }

  // 获取舆情数据统计数量
  export async function getSummaryData_GET() {
    return apiSendAsync<ApiJsonResult<object>>('GET', '/api/Yq/GetSummaryData', null, null);
  }

  // 导出
  export async function exportDeptYq_GET(query: {
    isPositive: boolean | null;
    reportState: boolean | null;
    eventCategoryId: string | null;
    keyword: string | null;
    theme: string | null;
    publisher: string | null;
    source: string | null;
    startPublishTime: Date | null;
    endPublishTime: Date | null;
    startCreationTime: Date | null;
    endCreationTime: Date | null;
    [key: string]: any;
  }) {
    return apiRequest<Blob>({
      method: 'GET',
      url: '/api/yq/ExportDeptYq',
      responseType: 'blob',
    });
  }
}

interface List<T> {
  [key: number]: T;
}
